export enum InputSizes {
  Normal = 0,
  Small = 1,
  Large = 2,
}

export default InputSizes;
